import { useQuery } from "@tanstack/react-query";

import { orpc } from "@/client";
export function FinanceiroNavBadge() {
	const { data } = useQuery(orpc.financeiro.reconciliation.nav.queryOptions());

	if (data === undefined) {
		return null;
	}

	const count = data.total;

	if (count === 0) {
		return null;
	}

	return (
		<span className="ml-auto rounded-full bg-warning px-1.5 py-0.5 text-xs font-medium text-warning-foreground">
			{count}
		</span>
	);
}
